import { lazy } from 'react';

// project import
import Loadable from 'components/Loadable';
import MinimalLayout from 'layout/MinimalLayout';
import { PublicRoute } from '../components/PublicRoute';

// render - login
const AuthLogin = Loadable(lazy(() => import('pages/authentication/Login')));
const AuthForgotPassword = Loadable(lazy(() => import('pages/authentication/ForgotPassword')));
const AuthResetPassword = Loadable(lazy(() => import('pages/authentication/ResetPassword')));
const AuthRegister = Loadable(lazy(() => import('pages/authentication/Register')));
const AuthThankYou = Loadable(lazy(() => import('pages/authentication/ThankYou')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  element: (
    <PublicRoute>
      <MinimalLayout />
    </PublicRoute>
  ),
  children: [
    {
      path: 'login',
      element: <AuthLogin />
    },
    {
      path: 'forgot-password',
      element: <AuthForgotPassword />
    },
    {
      path: 'reset-password',
      element: <AuthResetPassword />
    },
    {
      path: 'register',
      element: <AuthRegister />
    },
    {
      path: 'thank-you',
      element: <AuthThankYou />
    }
  ]
};

export default LoginRoutes;
